<template>
  <div class="c-list">
    <div
      class="c-item"
      :id="'card-item-' + index"
      v-for="(item, index) in cardList"
      :key="index"
      @click="bindClick(item)"
    >
      <WxOpenLaunchApp :extinfo="extinfo" sfrom="APP_CQHD"></WxOpenLaunchApp>
      <div class="c-card" :class="[item.draw_num ? 'c-front' : 'c-back']">
        <img class="front" :src="item.front_icon" alt="" />
        <img class="back" :src="item.backend_icon" alt="" />
        <div
          class="c-num animate__animated"
          :class="[item.animate ? 'animate__bounceIn' : '']"
          v-if="item.addNum > 0"
        >
          <div class="c-red">{{ item.addNum }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  components: { WxOpenLaunchApp },
  props: {
    cardList: {
      type: Array,
      default: () => []
    },
    extinfo: {
      type: String,
      default: ''
    },
    isApp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindChange(index) {},
    bindClick(item) {
      if (!this.isApp) {
        return
      }
      if (item.draw_num) {
        let id = item.theme_id
        this.$emit('preview', id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-list {
  padding: 0px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .c-item {
    perspective: 1000px;
    position: relative;
    width: 54px;
    height: 134px;

    .front,
    .back {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }

    .c-card {
      transition: all 0.3s ease;
      transform: rotateY(0deg);
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      transform-style: preserve-3d;

      .front {
        transform: rotateY(0deg);
        z-index: 2;
        backface-visibility: hidden;
        transform-style: preserve-3d;
      }

      .back {
        z-index: 1;
        backface-visibility: hidden;
        transform-style: preserve-3d;
        transform: rotateY(180deg);
      }
    }

    .c-front {
      transform: rotateY(0deg);
    }

    .c-back {
      transform: rotateY(180deg);
    }

    .c-num {
      z-index: 3;
      position: absolute;
      right: -8px;
      top: 0px;
      width: 18px;
      border-radius: 50%;
      height: 18px;
      background: linear-gradient(180deg, #fff9c2 0%, #fffde8 100%);

      .c-red {
        border-radius: 50%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        background: linear-gradient(
          180deg,
          #ffa7a7 0%,
          #ff9393 32%,
          #ff2d6f 100%
        );
        text-align: center;
        line-height: 14px;
        font-size: 11px;
        font-family: MiSans-Medium, MiSans;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .c-num-animate {
      animation: numAnimate 0.3s ease 0.3s;
    }
  }
}

@keyframes numAnimate {
  0% {
    opacity: 0;
    transform: scale(1);
  }

  20% {
    opacity: 0.5;
    transform: scale(0.9);
  }

  40% {
    opacity: 1;
    transform: scale(1.1);
  }

  60% {
    opacity: 0;
    transform: scale(0.9);
  }

  80% {
    opacity: 0;
    transform: scale(1.1);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
